module.exports = __webpack_public_path__ + "static/media/hand-holding-usd.d9aae4e1.svg";